// extracted by mini-css-extract-plugin
export var modalFooter = "_pt-0";